import { render, staticRenderFns } from "./appointmentGoodsList.vue?vue&type=template&id=57aac405&scoped=true&"
import script from "./appointmentGoodsList.vue?vue&type=script&lang=js&"
export * from "./appointmentGoodsList.vue?vue&type=script&lang=js&"
import style0 from "./appointmentGoodsList.vue?vue&type=style&index=0&id=57aac405&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57aac405",
  null
  
)

export default component.exports